/* Product page — Simply Carbon Fiber's own script (2026-09-11), companion to assets/pdp.css.
   Extends the stock Impulse product section with an exclusive case-or-bundle selector,
   matching colour/device media and prices, optional add-ons, and a mobile sticky bar.
   A kit purchase posts the bundle instead of the case, together with selected add-ons,
   in one /cart/add.js request. Ordinary partner products keep their existing behaviour. */
(function () {
  if (typeof window === 'undefined') return;

  function money(cents) {
    var out;
    try { out = theme.Currency.formatMoney(cents, theme.settings.moneyFormat); } catch (e) { out = '$' + (cents / 100).toFixed(2); }
    out = out.replace(/<[^>]+>/g, '');
    var code = window.Shopify && Shopify.currency && Shopify.currency.active;
    /* SCF 2026-10-13 (Sergio "go USD fix"): no code for US dollars, so the button reads "$52.99" like the rest of the
       site; other currencies keep it ("€41,95 EUR", "$67.00 CAD") so it's clear which money the shopper pays in. */
    if (code && code !== 'USD' && out.indexOf(code) === -1) out += ' ' + code;
    return out;
  }

  function parseVariants(el) {
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function initSection(section) {
    if (section.__scfPdp) return;
    var pdp = section.querySelector('.scf-pdp');
    var form = section.querySelector('form.product-single__form');
    if (!pdp || !form) return;
    section.__scfPdp = true;
    var atc = form.querySelector('[data-add-to-cart]');
    var variantJson = section.querySelector('[data-variant-json]');
    var variants = variantJson ? parseVariants(variantJson) : [];
    var idField = form.querySelector('[name="id"]');
    var current = null;

    function findVariant() {
      var id = idField ? String(idField.value) : '';
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === id) return variants[i];
      return null;
    }
    current = findVariant();
    var lastCaseVariant = current;

    /* ----- kit + add-on ----- */
    var kit = section.querySelector('[data-scf-kit]');
    var kitInputs = kit ? Array.prototype.slice.call(kit.querySelectorAll('.scf-kit__input')) : [];
    var addons = kit ? Array.prototype.slice.call(kit.querySelectorAll('.scf-addon__input')) : [];
    var kitValue = kit ? kit.querySelector('[data-scf-kit-value]') : null;
    var kitCurrentImg = kit ? kit.querySelector('[data-scf-kit-current-img]') : null;
    var bundleDataEl = section.querySelector('[data-scf-bundles]');
    var bundleData = bundleDataEl ? parseVariants(bundleDataEl) : {};
    var bundleProducts = bundleData.bundles || [];
    var selectedBundle = null, submitting = false, scheduled = false;
    var kitStatus = section.querySelector('[data-scf-kit-status]');
    var caseOnly = kitInputs.filter(function (r) { return !r.value && !r.dataset.bundleSeries; })[0];
    function norm(value) { return String(value || '').trim().toLowerCase(); }
    function quantity() { var field = form.elements.namedItem('quantity'); return Math.max(1, parseInt(field && field.value || '1', 10) || 1); }
    function bundleFor(input) {
      if (!current) return null;
      var style = current[bundleData.styleOption], device = current[bundleData.deviceOption];
      var products = bundleProducts.filter(function (p) { return norm(p.series) === norm(input.dataset.bundleSeries) && norm(p.style) === norm(style); });
      if (products.length !== 1 || !device) return null;
      var product = products[0];
      var matches = product.variants.filter(function (v) { return norm(v.device || v.title) === norm(device); });
      return matches.length === 1 ? { product: product, variant: matches[0] } : null;
    }
    function bundleGallery(match) {
      var references = match.variant.gallery;
      var library = match.product.media;
      if (!Array.isArray(references) || !Array.isArray(library)) return [];
      var byId = Object.create(null), seen = Object.create(null);
      library.forEach(function (media) {
        if (media && media.id && typeof media.src === 'string' && media.src) byId[String(media.id)] = media;
      });
      return references.reduce(function (images, id) {
        var key = String(id), media = byId[key];
        if (media && !seen[key]) { images.push(media); seen[key] = true; }
        return images;
      }, []);
    }
    function syncBundles() {
      selectedBundle = null;
      kitInputs.forEach(function (r) {
        if (!r.dataset.bundleSeries) return;
        var match = bundleFor(r), tile = r.closest('.scf-kit__tile');
        r.disabled = !match || !match.variant.available;
        r.value = match ? String(match.variant.id) : '';
        if (tile) {
          tile.classList.toggle('is-unavailable', r.disabled);
          var reason = tile.querySelector('[data-scf-kit-unavailable]');
          if (reason) { reason.hidden = !r.disabled; reason.textContent = match ? 'Sold out for this phone' : 'Not available in this colour / phone'; }
          var img = tile.querySelector('.scf-kit__img');
          if (img && match && match.variant.image) img.src = match.variant.image;
          var price = tile.querySelector('[data-scf-kit-price]');
          if (price && match) {
            price.textContent = money(match.variant.price);
            var was = price.parentNode.querySelector('s');
            if (!was && match.variant.compare_at_price > match.variant.price) { was = document.createElement('s'); price.parentNode.insertBefore(was, price); }
            if (was) { was.hidden = !(match.variant.compare_at_price > match.variant.price); was.textContent = was.hidden ? '' : money(match.variant.compare_at_price); }
          }
          var tag = tile.querySelector('.scf-kit__tag');
          if (tag) {
            var pct = match && match.variant.compare_at_price > match.variant.price ? Math.round((1 - match.variant.price / match.variant.compare_at_price) * 100 / 5) * 5 : 0;
            tag.textContent = pct + '% off'; tag.hidden = pct <= 0;
          }
        }
        if (!r.checked) return;
        if (r.disabled) {
          r.checked = false;
          if (caseOnly) caseOnly.checked = true;
          if (kitStatus) { kitStatus.hidden = false; kitStatus.textContent = 'This kit is not available for your selected colour and phone. Case only is selected.'; }
        } else selectedBundle = match;
      });
    }

    function deal(input) {   /* the product's own price; no display-only discount any more (2026-09-19) */
      return parseInt(input.dataset.price || '0', 10);
    }
    function extras(parentId, group) {
      var items = [];
      var parent = parentId ? { _scf_parent: String(parentId) } : {};
      if (group) parent._scf_parent_group = group;
      kitInputs.forEach(function (r) { if (r.checked && r.value && !r.dataset.bundleSeries) items.push({ id: parseInt(r.value, 10), quantity: quantity(), properties: Object.assign({}, parent, { _scf_kit: 'partner' }) }); });
      addons.forEach(function (a) { if (a.checked && a.value && !a.disabled) items.push({ id: parseInt(a.value, 10), quantity: quantity(), properties: Object.assign({}, parent, { _scf_kit: 'addon' }) }); });
      return items;
    }
    function total() {
      var sum = selectedBundle ? selectedBundle.variant.price : current ? current.price : 0;
      kitInputs.forEach(function (r) { if (r.checked && r.value && !r.dataset.bundleSeries) sum += deal(r); });
      addons.forEach(function (a) { if (a.checked && a.value) sum += deal(a); });
      return sum * quantity();
    }

    /* ----- total in the button + sticky bar ----- */
    var totalEl = atc ? atc.querySelector('.scf-atc-total') : null;
    if (atc && !totalEl) { totalEl = document.createElement('span'); totalEl.className = 'scf-atc-total'; atc.appendChild(totalEl); }
    var sticky = section.querySelector('[data-scf-sticky]');
    var stickyBtn = sticky ? sticky.querySelector('[data-scf-sticky-btn]') : null;
    var stickyText = sticky ? sticky.querySelector('[data-scf-sticky-text]') : null;
    var stickyTotal = sticky ? sticky.querySelector('[data-scf-total]') : null;
    var wasBundle = false;
    function renderPurchase() {
      var purchase = selectedBundle ? selectedBundle.variant : current || lastCaseVariant;
      if (!purchase) return;
      // The theme updates the case after variantChange; the final render below owns kit display.
      var price = section.querySelector('[data-product-price]');
      var compare = section.querySelector('[data-compare-price]');
      var compareWrap = section.querySelector('[data-product-price-wrap]');
      if (price && (selectedBundle || wasBundle)) {
        price.textContent = money(purchase.price);
        var sale = purchase.compare_at_price > purchase.price;
        if (sale && !compare) {
          compareWrap = document.createElement('span'); compareWrap.setAttribute('data-product-price-wrap', '');
          compare = document.createElement('span'); compare.setAttribute('data-compare-price', ''); compare.className = 'product__price product__price--compare';
          compareWrap.appendChild(compare); price.parentNode.insertBefore(compareWrap, price);
        }
        if (compare) compare.textContent = sale ? money(purchase.compare_at_price) : '';
        if (compareWrap) { compareWrap.classList.toggle('hide', !sale); compareWrap.removeAttribute('hidden'); }
        price.classList.toggle('on-sale', sale);
        var badge = section.querySelector('[data-scf-pct]');
        if (badge) {
          var pct = sale ? Math.round((1 - purchase.price / purchase.compare_at_price) * 100 / 5) * 5 : 0;
          badge.textContent = (badge.dataset.template || '[pct]% off').replace('[pct]', pct); badge.hidden = pct <= 0;
        }
        var savings = section.querySelector('[data-save-price]');
        if (savings) savings.hidden = !!selectedBundle;
      }
      // Express payment and installment quotes are bound to the case form, not the kit.
      section.querySelectorAll('.shopify-payment-button, .shopify-payment-terms').forEach(function (el) {
        if (selectedBundle && !el.hasAttribute('data-scf-was-hidden')) el.dataset.scfWasHidden = el.hidden ? 'true' : 'false';
        if (selectedBundle) el.hidden = true;
        else if (el.hasAttribute('data-scf-was-hidden')) { el.hidden = el.dataset.scfWasHidden === 'true'; delete el.dataset.scfWasHidden; }
      });
      if (window.SCFKitGallery) {
        if (selectedBundle) window.SCFKitGallery.set(section, { id: purchase.id, image: purchase.image_width && purchase.image_height ? { src: purchase.image, width: purchase.image_width, height: purchase.image_height } : purchase.image, alt: selectedBundle.product.title + ' — ' + purchase.title, media: bundleGallery(selectedBundle) });
        else if (wasBundle) window.SCFKitGallery.clear(section);
      }
      wasBundle = !!selectedBundle;
    }

    function render() {
      if (current) lastCaseVariant = current;
      syncBundles();
      var purchase = selectedBundle ? selectedBundle.variant : current;
      var available = !!(purchase && purchase.available);
      var t = money(total());
      if (totalEl) totalEl.textContent = available ? t : '';
      if (stickyTotal) stickyTotal.textContent = available ? t : '';
      if (stickyBtn) {
        stickyBtn.disabled = !available || submitting;
        if (stickyText && atc) {
          var txt = atc.querySelector('[data-add-to-cart-text]');
          if (txt) stickyText.textContent = txt.textContent.trim();
        }
      }
      kitInputs.forEach(function (r) {
        var tile = r.closest('.scf-kit__tile');
        if (tile) tile.classList.toggle('is-active', r.checked);
        if (r.checked && kitValue) kitValue.textContent = r.dataset.label || '';
      });
      if (atc) atc.disabled = !available || submitting;
      var src = current && current.featured_image && current.featured_image.src;
      if (src && kitCurrentImg) kitCurrentImg.src = src;
      renderPurchase();
    }

    function finalRender() {
      if (scheduled) return;
      scheduled = true;
      Promise.resolve().then(function () { scheduled = false; render(); });
    }

    /* the add-on follows the chosen Device (e.g. a screen guard variant named "iPhone 18 Pro") */
    function deviceValue(variant) {
      var wrap = section.querySelector('.variant-input-wrap[data-handle="device"], .variant-input-wrap[data-handle="phone-model"], .variant-input-wrap[data-handle="model"]');
      if (!wrap || !variant) return '';
      var key = wrap.dataset.index; // "option2"
      return key && variant[key] ? String(variant[key]) : '';
    }
    function addonRows(addon) {
      return (addon.dataset.variants || '').split(';').filter(Boolean).map(function (r) {
        var p = r.split('|');
        return { id: p[0], title: p[1] || '', price: parseInt(p[2] || '0', 10), img: p[3] || '', compare: parseInt(p[4] || '0', 10), parts: (p[1] || '').split(' / ').map(function (x) { return x.trim().toLowerCase(); }) };
      });
    }
    function syncAddonVariant() {
      var device = deviceValue(current).toLowerCase();
      addons.forEach(function (addon) {
        if (!addon.dataset.variants) return;
        var rows = addonRows(addon);
        var wrap = addon.closest('.scf-addon');
        var pickers = wrap ? Array.prototype.slice.call(wrap.querySelectorAll('[data-scf-dots]')) : [];
        var hasDeviceOpt = addon.dataset.deviceOption === 'true';   /* only when the add-on's Device values overlap the case's */
        var picked = pickers.map(function (p) { var on = p.querySelector('[data-value].is-active'); return on ? on.dataset.value.toLowerCase() : ''; }).filter(Boolean);
        var devOk = function (row) { return !device || !hasDeviceOpt || row.parts.indexOf(device) !== -1; };   /* exact: "iphone 15 pro" must not match "iphone 15 pro max" */
        var fits = function (row, withPicked) {
          if (!devOk(row)) return false;
          if (!withPicked) return true;
          return picked.every(function (v) { return row.parts.indexOf(v) !== -1; });
        };
        var match = null;
        for (var i = 0; i < rows.length && !match; i++) { if (fits(rows[i], true)) match = rows[i]; }
        for (var j = 0; j < rows.length && !match; j++) { if (fits(rows[j], false)) match = rows[j]; }   /* picked combination not made for this device: fall back to one that is */
        if (!match) {
          /* nothing made for this device: hide the row and drop it from the total */
          if (wrap) { wrap.hidden = true; }
          if (addon.checked) { addon.checked = false; }
          return;
        }
        if (wrap && wrap.hidden) { wrap.hidden = false; }
        addon.value = match.id; addon.dataset.price = String(match.price);
        var img = wrap ? wrap.querySelector('.scf-addon__img') : null;
        if (img && match.img) img.src = match.img;
        /* no manual % on this add-on: the slash price is the variant's own compare-at, so keep it in step */
        var priceEl = wrap ? wrap.querySelector('[data-scf-addon-price]') : null;
        if (priceEl && window.theme && theme.Currency) {
          var fm = function (c) { return theme.Currency.formatMoney(c, theme.settings.moneyFormat); };
          priceEl.innerHTML = (match.compare > match.price ? '<s>' + fm(match.compare) + '</s> ' : '') + '<b>' + fm(match.price) + '</b>';
        }
        pickers.forEach(function (p) {
          var others = pickers.filter(function (q) { return q !== p; }).map(function (q) { var on = q.querySelector('[data-value].is-active'); return on ? on.dataset.value.toLowerCase() : ''; }).filter(Boolean);
          p.querySelectorAll('[data-value]').forEach(function (d) {
            var v = d.dataset.value.toLowerCase();
            var made = rows.some(function (r) { return r.parts.indexOf(v) !== -1 && devOk(r); });
            d.classList.toggle('is-off', !made);
            d.classList.toggle('is-active', match.parts.indexOf(v) !== -1);
            if (d.classList.contains('scf-addon__opt')) d.setAttribute('aria-checked', d.classList.contains('is-active') ? 'true' : 'false');
          });
          var on = p.querySelector('[data-value].is-active');
          var name = p.matches('.scf-addon__dots--list') ? p.nextElementSibling : p.querySelector('[data-scf-dot-name]');
          if (name && name.hasAttribute('data-scf-dot-name') && on) name.textContent = on.dataset.value;
        });
      });
    }
    /* colour dots: pick a colour, tick the add-on, keep the device match */
    section.querySelectorAll('[data-scf-dots] [data-value]').forEach(function (dot) {
      dot.addEventListener('click', function (evt) {
        evt.preventDefault(); evt.stopPropagation();
        var dots = dot.closest('[data-scf-dots]');
        dots.querySelectorAll('[data-value]').forEach(function (d) { d.classList.remove('is-active'); });
        dot.classList.add('is-active');
        var input = dot.closest('.scf-addon').querySelector('.scf-addon__input');
        syncAddonVariant();
        if (!input.checked) { input.checked = true; }
        render();
      });
    });

    kitInputs.forEach(function (r) { r.addEventListener('change', function () { if (kitStatus) { kitStatus.hidden = true; kitStatus.textContent = ''; } render(); }); });
    addons.forEach(function (a) { a.addEventListener('change', render); });
    if (kitInputs.length) {
      var kitImgSrc = function (v) {
        var img = v && v.featured_image && v.featured_image.src;
        if (!img) return null;
        return img.indexOf('?') === -1 ? img + '?width=160' : img + '&width=160';
      };
      section.addEventListener('variantChange', function () {
        var src = kitImgSrc(current);
        if (src && kitCurrentImg) kitCurrentImg.src = src;
      });
    }

    /* ----- % off badge above the price (Price block toggle) ----- */
    var pctBadge = section.querySelector('[data-scf-pct]');
    if (pctBadge) {
      section.addEventListener('variantPriceChange', function (evt) {
        var v = evt.detail && evt.detail.variant;
        var pct = v && v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price / 5) * 5 : 0;   /* nearest 5, like the kit tiles */
        if (pct > 0) { pctBadge.textContent = (pctBadge.dataset.template || '[pct]% off').replace('[pct]', pct); pctBadge.hidden = false; }
        else { pctBadge.hidden = true; }
      });
    }

    section.addEventListener('variantChange', function (evt) {
      current = evt.detail && Object.prototype.hasOwnProperty.call(evt.detail, 'variant') ? evt.detail.variant : findVariant();
      syncAddonVariant();
      render();
      finalRender();
    });
    section.addEventListener('variantPriceChange', finalRender);
    if (idField) idField.addEventListener('change', function () { current = findVariant(); syncAddonVariant(); render(); finalRender(); });
    section.addEventListener('change', function (evt) { if (evt.target.name === 'quantity') render(); });
    section.__scfPdpRestore = function () {
      current = findVariant();
      syncAddonVariant();
      render();
      finalRender();
    };

    /* ----- One selected purchase: bundle OR case, plus explicit optional extras. ----- */
    document.addEventListener('submit', function (evt) {
      if (evt.target !== form) return;
      syncBundles();
      var hasExtras = extras(section.dataset.productId).length > 0;
      if (!selectedBundle && !hasExtras && !submitting) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      if (submitting || !form.reportValidity()) return;
      var purchase = selectedBundle ? selectedBundle.variant : current;
      if (!purchase || !purchase.available) { render(); return; }
      var data = new FormData(form), properties = {}, hasUploads = false;
      data.forEach(function (value, name) {
        var m = name.match(/^properties\[(.+)\]$/);
        if (m) { properties[m[1]] = value; if (typeof value !== 'string') hasUploads = true; }
      });
      var group = window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
      if (group) properties._scf_group = group;
      var main = { id: purchase.id, quantity: quantity(), properties: properties };
      if (!selectedBundle && data.get('selling_plan')) main.selling_plan = data.get('selling_plan');
      var items = [main].concat(extras(selectedBundle ? selectedBundle.product.id : section.dataset.productId, group));
      var headers = { 'X-Requested-With': 'XMLHttpRequest' }, body;
      if (hasUploads) {
        body = new FormData();
        items.forEach(function (item, index) {
          var prefix = 'items[' + index + ']';
          body.append(prefix + '[id]', item.id);
          body.append(prefix + '[quantity]', item.quantity);
          if (item.selling_plan) body.append(prefix + '[selling_plan]', item.selling_plan);
          Object.keys(item.properties || {}).forEach(function (name) { body.append(prefix + '[properties][' + name + ']', item.properties[name]); });
        });
      } else {
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify({ items: items, sections: 'cart-ajax-section' });   /* SCF 2026-09-22: drawer markup rides along (theme.js) */
      }
      if (body instanceof FormData) body.append('sections', 'cart-ajax-section');
      submitting = true;
      if (!(window.theme && theme.settings && theme.settings.cartType === 'page')) document.dispatchEvent(new CustomEvent('cart:adding', { detail: { form: form } }));   /* drawer opens now */
      var oldError = form.querySelector('.errors'); if (oldError) oldError.remove();
      if (atc) atc.classList.add('btn--loading');
      if (stickyBtn) stickyBtn.classList.add('is-loading');
      render();
      var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
      fetch(url, { method: 'POST', headers: headers, body: body })
        .then(function (r) { return r.json().then(function (result) {
          if (!r.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : result.message || 'Unable to add this selection. Please check your cart and try again.');
          return result;
        }); })
        .then(function (result) {
          if (theme.settings.cartType === 'page') { window.location.assign(theme.routes.cartPage); return; }
          var detail = { product: result.items ? result.items[0] : result, sections: result.sections, addToCartBtn: atc };
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: detail, bubbles: true }));
          if (section.dataset.productId) document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + section.dataset.productId, { detail: detail }));
        })
        .catch(function (error) {
          document.dispatchEvent(new CustomEvent('cart:add-failed', { detail: { message: error.message } }));
          var div = document.createElement('div'); div.className = 'errors text-center'; div.setAttribute('role', 'alert');
          div.textContent = error.message || 'Unable to add this selection. Please check your cart and try again.'; form.prepend(div);
          // A rejected inventory request may have partially changed the cart. Never blindly retry it.
          return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
            .then(function (cart) { document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: cart } })); })
            .catch(function () {});
        })
        .finally(function () {
          submitting = false;
          if (atc) atc.classList.remove('btn--loading');
          if (stickyBtn) stickyBtn.classList.remove('is-loading');
          render();
        });
    }, true);

    /* ----- sticky bar ----- */
    if (sticky && stickyBtn) {
      sticky.hidden = false;
      section.classList.add('scf-has-sticky');
      var onMobile = function () { return window.matchMedia('(max-width: 768px)').matches; };
      var setBody = function () { document.body.classList.toggle('scf-sticky-on', onMobile()); };
      setBody();
      window.addEventListener('resize', setBody);
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.disabled) return;
        if (form.requestSubmit) form.requestSubmit(atc || undefined);
        else if (form.reportValidity()) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
      if (atc && window.MutationObserver) {
        new MutationObserver(function () { stickyBtn.classList.toggle('is-loading', atc.classList.contains('btn--loading')); })
          .observe(atc, { attributes: true, attributeFilter: ['class'] });
      }
      // Theme preview only: Shopify's preview bar is fixed to the bottom too; sit above it.
      var liftAbovePreviewBar = function () {
        var bar = document.getElementById('preview-bar-iframe');
        if (bar && bar.offsetHeight) sticky.style.bottom = bar.offsetHeight + 'px';
      };
      [800, 2500, 6000].forEach(function (ms) { setTimeout(liftAbovePreviewBar, ms); });
    }

    syncAddonVariant();
    render();
  }

  function initAll() {
    document.querySelectorAll('.product-section[data-section-type="product"]').forEach(initSection);
  }
  // Back/Forward can restore checked inputs after pageshow without change events.
  // Reconcile on the next task; do not reinitialize the forms or submit handlers.
  window.addEventListener('pageshow', function () {
    setTimeout(function () {
      document.querySelectorAll('.product-section[data-section-type="product"]').forEach(function (section) {
        if (section.__scfPdpRestore) section.__scfPdpRestore();
      });
    }, 0);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target && e.target.querySelector('.product-section[data-section-type="product"]'); if (s) { s.__scfPdp = false; initSection(s); } });
  document.addEventListener('quickview:loaded', initAll);
})();
